import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function PainPoints() {
  const painPoints = ['Liquidar sueldos sin equivocarse y sin un contador al lado', 'Miedo a un juicio laboral por un despido mal documentado', 'Ausencias, certificados médicos y licencias sin saber qué corresponde', 'Legajos desordenados y papeles que faltan cuando los pide un inspector', 'Tener que resolver conflictos, sanciones y vacaciones sola y sin tiempo'];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-127">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-128">
        El problema no es trabajar en RRHH. Es tener que resolver todo sola.
      </h2>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-129">
        {painPoints.map((pain, index) => <div key={index} className="bg-red-50 border border-red-200 rounded-lg p-5 flex items-start gap-3 hover:shadow-md transition-shadow duration-300" data-id="element-130">
            <AlertCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-131" />
            <p className="text-gray-800 leading-relaxed" data-id="element-132">{pain}</p>
          </div>)}
      </div>
    </section>;
}